// Why the API says a completed review cannot be edited, keyed by the editBlockedReason it returns
// beside canEdit on the completed review and on each Completed Reviews search row.
const editBlockedMessages = {
    NOTLATEST: "Only the most recent review of this type can be edited.",
    TOPICRESTRICTED: "This review includes a topic you do not have permission to review, so it cannot be edited."
};

const unknownEditBlockedMessage = "This review cannot be edited.";

// A reason this page does not recognise still explains that the review cannot be edited.
export function getEditBlockedMessage(editBlockedReason) {
    return editBlockedMessages[editBlockedReason] ?? unknownEditBlockedMessage;
}
